export default {
	LOGIN_START                   : 'LOGIN_START',
	LOGIN_SUCCESS                 : 'LOGIN_SUCCESS',
	LOGIN_FAILURE                 : 'LOGIN_FAILURE',
	REGISTER_START                : 'REGISTER_START',
	REGISTER_SUCCESS              : 'REGISTER_SUCCESS',
	REGISTER_FAILURE              : 'REGISTER_FAILURE',
	LOGOUT                        : 'LOGOUT',
	GET_CATEGORIES_START          : 'GET_CATEGORIES_START',
	GET_CATEGORIES_SUCCESS        : 'GET_CATEGORIES_SUCCESS',
	GET_CATEGORIES_FAILURE        : 'GET_CATEGORIES_FAILURE',
	GET_FAMILY_MEMBERS_START      : 'GET_FAMILY_MEMBERS_START',
	GET_FAMILY_MEMBERS_SUCCESS    : 'GET_FAMILY_MEMBERS_SUCCESS',
	GET_FAMILY_MEMBERS_FAILURE    : 'GET_FAMILY_MEMBERS_FAILURE',
	GET_SINGLE_USER_START         : 'GET_SINGLE_USER_START',
	GET_SINGLE_USER_SUCCESS       : 'GET_SINGLE_USER_SUCCESS',
	GET_SINGLE_USER_FAILURE       : 'GET_SINGLE_USER_FAILURE',
	UPDATE_ACCOUNT_START          : 'UPDATE_ACCOUNT_START',
	UPDATE_ACCOUNT_SUCCESS        : 'UPDATE_ACCOUNT_SUCCESS',
	UPDATE_ACCOUNT_FAILURE        : 'UPDATE_ACCOUNT_FAILURE',
	ADD_FAMILY_MEMBER_START       : 'ADD_FAMILY_MEMBER_START',
	ADD_FAMILY_MEMBER_SUCCESS     : 'ADD_FAMILY_MEMBER_SUCCESS',
	ADD_FAMILY_MEMBER_FAILURE     : 'ADD_FAMILY_MEMBER_FAILURE',
	WELCOME_BACK_START            : 'WELCOME_BACK_START',
	WELCOME_BACK_SUCCESS          : 'WELCOME_BACK_SUCCESS',
	WELCOME_BACK_FAILURE          : 'WELCOME_BACK_FAILURE',
	CREATE_TASK_START             : 'CREATE_TASK_START',
	CREATE_TASK_SUCCESS           : 'CREATE_TASK_SUCCESS',
	CREATE_TASK_FAILURE           : 'CREATE_TASK_FAILURE',
	GET_FAMILY_CATEGORIES_START   : 'GET_FAMILY_CATEGORIES_START',
	GET_FAMILY_CATEGORIES_SUCCESS : 'GET_FAMILY_CATEGORIES_SUCCESS',
	GET_FAMILY_CATEGORIES_FAILURE : 'GET_FAMILY_CATEGORIES_FAILURE',
	CREATE_CATEGORY_START         : 'CREATE_CATEGORY_START',
	CREATE_CATEGORY_SUCCESS       : 'CREATE_CATEGORY_SUCCESS',
	CREATE_CATEGORY_FAILURE       : 'CREATE_CATEGORY_FAILURE',
	COMPLETE_TASK_START           : 'COMPLETE_TASK_START',
	COMPLETE_TASK_SUCCESS         : 'COMPLETE_TASK_SUCCESS',
	COMPLETE_TASK_FAILURE         : 'COMPLETE_TASK_FAILURE',
	UPDATE_TASK_START             : 'UPDATE_TASK_START',
	UPDATE_TASK_SUCCESS           : 'UPDATE_TASK_SUCCESS',
	UPDATE_TASK_FAILURE           : 'UPDATE_TASK_FAILURE',
	FAMILY_TASKS_SUCCESS		  : 'FAMILY_TASKS_SUCCESS',
	RESET							: 'RESET'
};
